import makeStyles from "@mui/styles/makeStyles";

import { relativeCTABackgrounds } from "utils/relativeUtils";

export default makeStyles(
  (theme) => ({
    paper: {
      width: 340,
      height: 412,
      padding: [20, 26, 28],
      position: "relative",
      borderRadius: 10,
      overflowY: "initial",
    },
    buttonClose: {
      position: "absolute",
      right: 12,
      top: 12,
      width: 12,
      height: 12,
      fontSize: theme.typography.pxToRem(12),
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    title: {
      width: 200,
      marginBottom: 20,
    },
    faces: {
      marginBottom: 10,
      display: "flex",
      borderRadius: 6,
      backgroundColor: theme.palette.common.white,
    },
    facePic: {
      width: 60,
      height: "100%",
      marginLeft: 5,
      "&:first-child": {
        marginLeft: 0,
      },
      "&:nth-child(n+4)": {
        display: "none",
      },
    },
    description: {
      width: 200,
      marginBottom: 10,
      textAlign: "center",
    },
    ...relativeCTABackgrounds(theme),
  }),
  { name: "CTAModal" },
);
